angular.module('currency', ['core'])
    .factory('Currency', function ($resource, $filter) {
        var Currency = $resource('/crm/api/currency/:id', {}, {
            list: {method: 'GET', isArray: true},
            get: {method: 'GET'},
            table: {method: 'GET', isArray: false, url: '/crm/api/currency/table'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'}
        });
        Currency.getDefault = items => items.find(item => item.isDefault === true);
        return Currency;
    })
    .service('CurrencyService', function ($rootScope, modals, Currency) {
        this.edit = id => {
            return Currency.get({id: id}, entity => this.editModal(entity));
        }
        this.editModal = entity => {
            return modals.open('app/currency/edit-modal.html', 'CurrencyDialogController', entity, {size: 'md'}, "$ctrl");
        };
        this.addModal = () => {
            let entity = {
                id: null
            };
            return this.editModal(entity);
        };
        this.remove = item => {
            return modals.confirmDelete(item.symbol, () => Currency.delete({id: item.id}, () => $rootScope.$broadcast('currency.updated')).$promise);
        };
    })
    .component('currencyList', {
        bindings: {
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/currency/list.html',
        controller: function ($scope, $state, CurrencyService) {
            this.CurrencyService = CurrencyService;
            this.reset = () => this.filters = {};
            $scope.$on('currency.updated', () => $state.reload());
        }
    })
    .controller('CurrencyDialogController', function ($rootScope, $uibModalInstance, data, toastr, Currency) {
        this.item = data;
        this.cancel = () => $uibModalInstance.dismiss('Canceled');

        this.save = () => {
            let promise;
            if (this.item.id !== null) {
                promise = Currency.update(this.item).$promise;
            } else {
                promise = Currency.save(this.item).$promise;
            }
            return promise.then(result => {
                $rootScope.$broadcast('currency.updated');
                $uibModalInstance.close(result);
                toastr.success("Zapisano rekord");
            });
        };
    })
    .config(function ($stateProvider) {
        $stateProvider.state('currencyList', {
            parent: 'app',
            url: '/currency?{page:int}&{size:int}&sort&search',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': "currencyList"
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (Currency, $q, $stateParams) => Currency.table(angular.copy($stateParams)).$promise
            }
        });
    });
